/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.13.0
 * @since 1.13.0
 */

import { IWizardExpensesDetailReducer } from './wizardExpensesDetailReducer';

export enum EWizardExpensesDetailSteps {
    StepSelectParams = 'PrepareStep',
    StepConfirmation = 'ConfirmStep',
}

export const initWizardExpensesDetailState: IWizardExpensesDetailReducer = {
    date: '',
    formatsAvailable: [],
    formatsAvailableChosen: '',
    hierarchyLevels: [],
    hierarchyLevelsChosen: {
        id: 0,
        isAvailable: false,
        label: '',
        order: 0,
        reason: '',
    },
    maxDate: '',
    validation: {
        error: '',
        isValid: false,
    },
};

/*
* -------------------------------------------
*           ACTIONS
* -------------------------------------------
*/

export const WIZARD_EXPENSES_DETAIL_HANDLE_NEXT = '@@b2b_portal_ui/wizardExpensesDetail/WIZARD_EXPENSES_DETAIL_HANDLE_NEXT';

export const WIZARD_EXPENSES_DETAIL_SET_PARAMS = '@@b2b_portal_ui/wizardExpensesDetail/WIZARD_EXPENSES_DETAIL_SET_PARAMS';
export const WIZARD_EXPENSES_DETAIL_UPDATE_DATA = '@@b2b_portal_ui/wizardExpensesDetail/WIZARD_EXPENSES_DETAIL_UPDATE_DATA';

export const WIZARD_EXPENSES_DETAIL_VALIDATION = '@@b2b_portal_ui/wizardExpensesDetail/WIZARD_EXPENSES_DETAIL_VALIDATION';
export const WIZARD_EXPENSES_DETAIL_CHECK_VALIDATION = '@@b2b_portal_ui/wizardExpensesDetail/WIZARD_EXPENSES_DETAIL_CHECK_VALIDATION';
